import React, { createContext, useMemo } from "react";

/**
 * Set by a surface that can host a route-level flow inline (today: the Users
 * split panel). Null everywhere else, which is what makes `useFlowNavigate`
 * degrade to plain routing on the full-page dashboard.
 *
 * @type {React.Context<{canEmbed: (to: string) => boolean,
 *   open: (to: string, options?: Object) => void}|null>}
 */
export const EmbeddedFlowHostContext = createContext(null);

/**
 * Provides the embed capability to everything beneath it.
 *
 * @param {Object} props
 * @param {(to: string) => boolean} props.canEmbed - Whether this host can
 *   render the given path inline.
 * @param {(to: string, options?: Object) => void} props.onOpen - Open it.
 */
export function EmbeddedFlowHostProvider({ canEmbed, onOpen, children }) {
  const value = useMemo(
    () => ({ canEmbed, open: onOpen }),
    [canEmbed, onOpen]
  );
  return (
    <EmbeddedFlowHostContext.Provider value={value}>
      {children}
    </EmbeddedFlowHostContext.Provider>
  );
}

// The navigate hook that consumes this context lives in embeddedRoute.jsx,
// alongside the in-flow context it also has to consult. Keeping it there
// avoids a circular import between the two modules.
